import { render, staticRenderFns } from "./BusinessRulesManagement.vue?vue&type=template&id=43fd4b2c&scoped=true&"
import script from "./BusinessRulesManagement.vue?vue&type=script&lang=js&"
export * from "./BusinessRulesManagement.vue?vue&type=script&lang=js&"
import style0 from "./BusinessRulesManagement.vue?vue&type=style&index=0&id=43fd4b2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43fd4b2c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/acarmichael/Desktop/DEV/BOSS40-FrontEnd/boss-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
installComponents(component, {VCard,VDataTable})
